import _ from 'lodash'

import { LoadingContainer, Model, Modal, Select } from 'peach/components'
import { useParams } from 'peach/router'
import { getName } from 'peach/helpers'

import { Page } from 'core/components'
import {
  useInternalFeesGet,
  useInternalFeesCancelOne,
  useInternalFeesPost,
  useInternalLoanGet,
} from 'core/types'

import LoanFeeForm from './LoanFees/LoanFeeForm'

const LoanFees = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const { data: loan } = useInternalLoanGet({
    companyId,
    personId,
    loanId,
  })

  const {
    data: fees,
    isLoading,
    error,
  } = useInternalFeesGet({
    companyId,
    personId,
    loanId,
  })

  const { mutateAsync: cancelFee } = useInternalFeesCancelOne({
    companyId,
    personId,
    loanId,
    loanFeeId: undefined,
  })

  const { mutateAsync: chargeFee } = useInternalFeesPost({
    companyId,
    personId,
    loanId,
  })

  const $fees = _.filter(fees, (fee) => fee?.dynamicFeeDetails?.loanFeeId)

  return (
    <LoadingContainer error={error} loading={isLoading}>
      <Modal
        initialValue={{ loanFeeId: null, caseId: null }}
        onSubmit={async ({ loanFeeId, caseId }) => {
          await cancelFee(
            {
              caseId,
            },
            {
              companyId,
              personId,
              loanId,
              loanFeeId,
            },
          )
        }}
        title='Cancel Fee'
      >
        <Select
          formKey='loanFeeId'
          options={_.map($fees, (fee) => {
            const value = fee?.dynamicFeeDetails?.loanFeeId
            return { label: getName(fee), value, disabled: !value }
          })}
        />
      </Modal>
      <Modal
        onSubmit={async (fee) => {
          await chargeFee(fee, {
            companyId,
            personId,
            loanId,
          })
        }}
        render={({ value, onChange }) => (
          <LoanFeeForm
            loanTypeId={loan?.loanTypeId}
            onChange={onChange}
            value={value}
          />
        )}
        title='Charge Fee'
      />
      <Page variant='full'>
        <Model.Item json={fees} />
      </Page>
    </LoadingContainer>
  )
}

export default LoanFees
